// extracted by mini-css-extract-plugin
export default {"container":"AdminLoginPage_container__MZq3m","success":"AdminLoginPage_success__O3fvE"};